import React, { useState, useEffect, useContext } from "react";
import ProjectForm from "../components/Project/ProjectForm";
import ProjectList from "../components/Project/ProjectList";
import { fetchWorkspaces } from "../api/api";
import { AuthContext } from "../context/AuthContext";

const Projects = () => {
  const { user } = useContext(AuthContext);
  const [workspaces, setWorkspaces] = useState([]);
  const [workspaceId, setWorkspaceId] = useState(null);
  const [refresh, setRefresh] = useState(false);

  useEffect(() => {
    if (!user?.id) return;

    const loadWorkspaces = async () => {
      const data = await fetchWorkspaces(user.id);
      setWorkspaces(data || []);
      if (data?.length) setWorkspaceId(data[0].id);
    };

    loadWorkspaces();
  }, [user]);

  return (
    <div>
      <h3 className="mb-4">Projects</h3>

      {workspaces.length > 0 && (
        <select
          className="form-select mb-3"
          value={workspaceId}
          onChange={(e) => setWorkspaceId(Number(e.target.value))}
        >
          {workspaces.map((ws) => (
            <option key={ws.id} value={ws.id}>
              {ws.name}
            </option>
          ))}
        </select>
      )}

      {workspaceId && (
        <ProjectForm
          workspace_id={workspaceId}
          onProjectCreated={() => setRefresh(!refresh)}
        />
      )}

      {workspaceId && (
        <ProjectList
          workspace_id={workspaceId}
          refresh={refresh}
        />
      )}
    </div>
  );
};

export default Projects;
